import React, { useCallback, useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { Link, useNavigate } from "react-router-dom";
import { InfiLoader } from "../components/loader";
import ButtonContainer from "../components/buttonContainer";
import { IoAddOutline } from "react-icons/io5";
import SearchContainer from "../components/searchContainer";
import { PopModel } from "../components/popupModels";
import BackHeader from "../components/backHeader";
import Pagination from "../components/pagination";
import DataNotFound from "../components/dataNotFound";
import Card from "../components/card";
import { toast } from "react-toastify";
// import { AiTwotoneEdit } from "react-icons/ai";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import { FiSearch } from "react-icons/fi";
// import { IoMdAddCircle } from "react-icons/io";

function Customers() {
  const { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  const navigate = useNavigate();
  const [showImportContainer, setShowImportContainer] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteCustomersLoading, setDeleteCustomersLoading] = useState(false);
  console.log("CUSTOMERS IS :========>>>>>>", customers);
  const [searchInput, setSearchInput] = useState("");

  // =================== PAGINATION =================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  const [deleteCustomerIds, setDeleteCustomerIds] = useState([]);
  const [isDeleted, WantToDelete] = useState(false);

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // =======================================================

  // const fetchCustomerData = async (vendorObjId) => {
  //   setLoading(true);
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     page: currentPage,
  //     limit: JSON.parse(itemsPerPage),
  //   });
  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/customer/get`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("Customer Data:", response.data);
  //       // setAppData(response.data.data);
  //       // setLoading(false);
  //       setCustomers(response?.data?.data);
  //       setLoading(false);
  //       setPaginationData(response?.data?.pagination);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // };
  const fetchCustomerData = useCallback(async () => {
    setLoading(true);

    const data = JSON.stringify({
      vendorObjId,
      page: currentPage,
      limit: JSON.parse(itemsPerPage),
    });

    const config = {
      method: "post",
      url: `${apiurl}/admin/v1/customer/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    try {
      const response = await axios.request(config);
      setCustomers(response?.data?.data);
      setPaginationData(response?.data?.pagination);
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  }, [vendorObjId, currentPage, itemsPerPage]);

  const handleEditCustomer = (id) => {
    navigate(`/customers/view/${id}`);
  };

  const filterdata =
    customers &&
    customers?.filter(
      (customer) =>
        customer?.name?.toLowerCase().includes(searchInput?.toLowerCase()) ||
        customer?.phone?.toLowerCase().includes(searchInput?.toLowerCase()),
    );

  const AllCheckedHandler = () => {
    if (filterdata.length !== deleteCustomerIds.length) {
      filterdata.forEach((item) =>
        setDeleteCustomerIds((prev) => [...prev, item._id]),
      );
    } else {
      setDeleteCustomerIds([]);
    }
  };

  const CheckedHandler = (id) => {
    const contain = deleteCustomerIds.includes(id);
    console.log("containcontain", contain, id);
    if (contain) {
      setDeleteCustomerIds(deleteCustomerIds.filter((i) => i !== id));
    } else {
      setDeleteCustomerIds((prev) => [...prev, id]);
    }
  };

  // useEffect(() => {
  //   fetchCustomerData(vendorObjId);
  // }, [currentPage, itemsPerPage]);
  useEffect(() => {
    fetchCustomerData();
  }, [fetchCustomerData]);

  const DeleteHandler = () => {
    setDeleteCustomersLoading(true);
    let data = JSON.stringify({
      customerObjIds: deleteCustomerIds,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/customer/delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response.data.message
              ? response.data.message
              : "Customer deleted successfully",
          );
          WantToDelete(false);
          fetchCustomerData(vendorObjId);
          setDeleteCustomersLoading(false);
          setDeleteCustomerIds([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setDeleteCustomersLoading(false);
      });
  };

  console.log("deleteCustomerIds", deleteCustomerIds);
  return (
    <Layout>
      {isDeleted && (
        <Card.Confirmation
          message="Are you sure?"
          onConfirm={() => DeleteHandler()}
          onClose={() => WantToDelete(false)}
          loading={deleteCustomersLoading}
          loadingTitle="Deleting..."
        />
      )}
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Customers Data..." />
        ) : (
          // <div>
          //     <div className="border borderda-2 border-slate-200 md:rounded-xl w-full px-5 py-3">
          //         <div className="flex justify-between my-4">
          //             <div>
          //                 <h1 className="text-3xl font-medium text-center mb-3 text-slate-500">
          //                     Our Customers
          //                 </h1>
          //             </div>
          //             <div className="flex gap-5 items-center">
          //                 <div>
          //                     <Link to="/customers/add">
          //                         <button className="bg-slate-500 hover:bg-slate-600 text-white font-semibold py-2 px-4 rounded-lg">
          //                             Add Customer
          //                         </button>
          //                     </Link>
          //                 </div>

          //                 <div className="flex items-center py-1 px-3 rounded-full bg-gray-50 border focus-within:border-gray-300 max-w-xl">
          //                     <FiSearch className="text-gray-400 text-xl" />
          //                     <input
          //                         type="text"
          //                         placeholder="search Customer..."
          //                         className="bg-transparent w-full focus:outline-none pr-4 font-semibold border-0 focus:ring-0 px-2"
          //                         value={searchInput}
          //                         onChange={(e) => setSearchInput(e.target.value)}
          //                     />
          //                     <button className="flex items-center justify-center min-w-[130px] px-4 rounded-full bg-slate-500 text-white font-medium border-transparent py-1.5 h-[38px] -mr-3">
          //                         Search
          //                     </button>
          //                 </div>
          //             </div>
          //         </div>
          //         <div className="flex flex-col">
          //             <div className="overflow-x-auto sm:rounded-lg h-[540px]">
          //                 <table className="w-full text-sm text-left rtl:text-right text-gray-500  max-h-96">
          //                     <thead className="text-xs text-gray-700 uppercase bg-gray-50   sticky top-0">
          //                         <tr>
          //                             {/* <th scope="col" className="px-6 py-3">
          //                             SR No.
          //                         </th> */}
          //                             <th scope="col" className="px-6 py-3">
          //                                 Name
          //                             </th>
          //                             <th scope="col" className="px-6 py-3 ">
          //                                 Email
          //                             </th>
          //                             <th scope="col" className="px-6 py-3 ">
          //                                 Phone No.
          //                             </th>

          //                             {/* <th scope="col" className="px-6 py-3 flex justify-center">
          //                             Action
          //                         </th> */}
          //                         </tr>
          //                     </thead>

          //                     <tbody className="h-[100%]">
          //                         {customers.map((customer, index) => (
          //                             <tr
          //                                 key={index}
          //                                 className={`${index % 2 === 0
          //                                         ? "odd:bg-white "
          //                                         : "even:bg-gray-50 "
          //                                     } border-b   max-h-5 cursor-pointer`}
          //                                 onClick={() => handleEditCustomer(customer._id)}
          //                             >
          //                                 {/* <th
          //                                 scope="row"
          //                                 className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
          //                             >
          //                                 {customer.srNo}
          //                             </th> */}
          //                                 <th
          //                                     scope="row"
          //                                     className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
          //                                 >
          //                                     {customer.name}
          //                                 </th>

          //                                 <td className="px-6 py-4">{customer.email}</td>
          //                                 <td className="px-6 py-4">{customer.phone}</td>
          //                                 {/* <td className="px-6 py-4">{product.price}</td> */}
          //                                 {/* <td className="px-6 py-4 flex justify-center">
          //                                 <div className='flex align-middle gap-3'>
          //                                     <div className='h-8 w-8 flex justify-center align-middle rounded-md text-lg pt-2 text-slate-500 hover:text-red-700 hover:bg-red-200 ' ><RiDeleteBin6Fill /></div>
          //                                 </div>
          //                             </td> */}
          //                             </tr>
          //                         ))}
          //                     </tbody>
          //                 </table>
          //             </div>
          //         </div>
          //     </div>
          // </div>

          <div className=" rounded-lg h-full w-full flex flex-col px-2 md:px-5 ">
            {/* <div className="flex flex-col md:flex-row justify-between my-4">
                            <div>
                                <h1 className="text-3xl font-medium text-center mb-3 text-slate-500">Our Customers</h1>
                            </div>
                            <div className="flex flex-col md:flex-row gap-4 items-center">
                                <Link to="/customers/add">
                                    <button className="bg-slate-500 hover:bg-slate-600 text-white font-semibold py-2 px-4 rounded-lg">
                                        Add Customer
                                    </button>
                                </Link>
                                <div className="flex items-center py-1 px-3 rounded-full bg-gray-50 border focus-within:border-gray-300 max-w-xl w-full md:w-auto">
                                    <FiSearch className="text-gray-400 text-xl" />
                                    <input
                                        type="text"
                                        placeholder="Search Customer..."
                                        className="bg-transparent w-full focus:outline-none pr-4 font-semibold border-0 focus:ring-0 px-2"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                    />
                                    <button className="flex items-center justify-center min-w-[130px] px-4 rounded-full bg-slate-500 text-white font-medium border-transparent py-1.5 h-[38px] -mr-3">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div> */}
            <div className="h-[96%] overflow-hidden">
              <BackHeader
                title={
                  <span className="flex flex-col md:flex-row items-center items-center">
                    Customers
                    <span className="hidden lg:flex">
                      {" "}
                      - {paginationData?.totalItems}
                    </span>
                    <select
                      value={itemsPerPage}
                      className="text-xs rounded text-black border px-2 mx-2"
                      onChange={(e) => setItemsPerPage(e.target.value)}
                    >
                      {/* <option value="10">10</option> */}
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="250">250</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </span>
                }
                rightSide={
                  <div className="flex gap-2">
                    <div className="flex gap-2 md:hidden">
                      {deleteCustomerIds.length > 0 &&
                        userData?.userType === "superadmin" && (
                          <button
                            onClick={() => WantToDelete(true)}
                            className="bg-red-50 text-xs hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg px-2 py-1 md:py-2 md:px-3 "
                          >
                            Delete
                          </button>
                        )}

                      <button
                        className="border text-xs md:text-base  sm:p-2 px-3 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white"
                        onClick={() => setShowImportContainer(true)}
                      >
                        Import
                      </button>
                      <Link to="/customers/create">
                        <ButtonContainer
                          icon={<IoAddOutline />}
                        ></ButtonContainer>
                      </Link>
                    </div>
                    <div className="hidden md:flex items-center gap-2">
                      {deleteCustomerIds.length > 0 &&
                        userData?.userType === "superadmin" && (
                          <button
                            onClick={() => WantToDelete(true)}
                            className="bg-red-50 md:text-sm lg:text-base hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg py-2 px-3 "
                          >
                            Delete
                          </button>
                        )}
                      {userData?.userType !== "admin" ? (
                        <button
                          className="border md:text-sm lg:text-base py-2 px-3 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white"
                          onClick={() => setShowImportContainer(true)}
                        >
                          Import
                        </button>
                      ) : null}
                      <Link to="/customers/create">
                        <ButtonContainer icon={<IoAddOutline />}>
                          Create
                        </ButtonContainer>
                      </Link>
                    </div>
                    <div className="hidden md:flex">
                      <SearchContainer
                        value={searchInput}
                        placeholder={"Search Customer..."}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                    </div>
                  </div>
                }
              />

              <div className="flex flex-col  h-[90%] overflow-auto mt-2">
                <div className=" sm:rounded-lg h-full">
                  {filterdata && filterdata.length > 0 ? (
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 max-h-96">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                        <tr>
                          <th scope="col" class="p-4">
                            <div class="flex items-center">
                              <input
                                id="checkbox-all-search"
                                type="checkbox"
                                checked={
                                  filterdata.length === deleteCustomerIds.length
                                }
                                onClick={AllCheckedHandler}
                                class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 "
                              />
                              <label for="checkbox-all-search" class="sr-only">
                                checkbox
                              </label>
                            </div>
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Name
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Email
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Phone No.
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="h-full">
                        {filterdata &&
                          filterdata.length > 0 &&
                          filterdata.map((customer, index) => (
                            <tr
                              key={index}
                              className={`${
                                index % 2 === 0
                                  ? "odd:bg-white"
                                  : "even:bg-gray-50"
                              } border-b cursor-pointer`}
                            >
                              <td class="w-4 p-4">
                                <div class="flex items-center">
                                  <input
                                    id="checkbox-table-search-1"
                                    type="checkbox"
                                    checked={deleteCustomerIds.includes(
                                      customer._id,
                                    )}
                                    onClick={() => CheckedHandler(customer._id)}
                                    class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2 "
                                  />
                                  <label
                                    for="checkbox-table-search-1"
                                    class="sr-only"
                                  >
                                    checkbox
                                  </label>
                                </div>
                              </td>
                              <th
                                scope="row"
                                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                              >
                                {customer.name}
                              </th>
                              <td className="px-6 py-4">{customer.email}</td>
                              <td className="px-6 py-4">{customer.phone}</td>
                              <td
                                className="pl-4 sm:pl-6 py-4 text-blue-500 "
                                onClick={() => handleEditCustomer(customer._id)}
                              >
                                view
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  ) : (
                    <DataNotFound.Page label="Customer" />
                  )}
                </div>
              </div>
            </div>

            <Pagination
              currentPage={currentPage}
              totalItems={paginationData?.totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </Container>

      {showImportContainer && (
        <PopModel setShowImportContainer={setShowImportContainer}></PopModel>
      )}
    </Layout>
  );
}

export default Customers;
